module.exports = __webpack_public_path__ + "img/degiro-dark.c32d5a29.png";